import apiHelper from '../utils/apiHelper';

export const userImportService = {
  /**
   * Import an array of users into Auth0.
   * @param {Array<{firstName: string, lastName: string, email: string}>} users
   * @returns {Promise<{total, created, skipped, failed, results}>}
   */
  importUsers: async (users) => {
    try {
      const count = Array.isArray(users) ? users.length : 0;
      const timeout = Math.max(120000, count * 4000);
      const response = await apiHelper.post(
        '/api/user-import/import',
        { users },
        { timeout },
      );
      return response.data;
    } catch (error) {
      console.error('User import failed:', error);
      throw error;
    }
  },
};
